import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Phase, Release } from '../services/release.service';

@Component({
  selector: 'current-phase',
  template: `
  <div class="current-phase lx-body">
    <span class="progressStatus {{statusCss}}"></span>
    <span>{{phase}}</span>
  </div>`,
  styleUrls: ['./current-phase.component.scss']
})

export class CurrentPhaseComponent implements ICellRendererAngularComp {

  constructor() { }

  phase: string;
  statusCss: string;
  // gets called once before the renderer is used
  agInit(params: ICellRendererParams): void {
    this.statusCss = this.getStatusCss(params.data.status);
    this.phase = this.getStatusName(params.data);
  }

  // gets called whenever the cell refreshes
  refresh(params: ICellRendererParams): boolean {
    // set value into cell again
    this.phase = params.data.status;
    return true;
  }

  getStatusCss(status: string): string{
    switch (status) {
      case 'PendingReview':
        return 'pending'
      case 'InProgress':
        return 'in_progress'
      default:
        return status.toLowerCase()
    }
  }

  getStatusName(release: Release): string{
    if(release.status == "Disabled" || release.status == "Rejected" || release.status == "Deployed"){
      return release.status;
    }
    else if(release.phases.every(p => p.status == "Scheduled") || release.status == "PendingReview"){
      return "Scheduled";
    }
    else{
      let earliestScheduledPhase = release.phases.filter(p=> p.status == "Scheduled")[0];
      return earliestScheduledPhase.name;
    }
  }
}

